import _ from 'lodash';
import { DateTime, Time, UTCDate } from '@skyjs/date';
import Collection from '@skyjs/collection';

const standardizeParamValue = (value, type) => {
  switch (type) {
    case 'NUMBER':
      return Number(value);
    case 'BOOLEAN':
      return Boolean(value);
    case 'UTCDATE':
      return new UTCDate(value);
    case 'DATETIME':
      return new DateTime(value);
    case 'TIME':
      return new Time(value);
    default:
      return value;
  }
};

export default function standardizeParams(params, paramsDefinition) {
  Collection.fromArray(paramsDefinition).forEach(param => {
    // Un paramètre omis reste déclaré, sans valeur : le code de l'API peut le lire par son nom.
    params[param.name] = _.has(params, param.name)
      ? standardizeParamValue(params[param.name], param.type)
      : undefined;
  });
}
